import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var i = /*#__PURE__*/function () {
  function i(_i, s, t, e) {
    _classCallCheck(this, i);

    this.semiMajorAxis = _i, this.flattening = s, this.outerAtmosphereRimWidth = t;
    var h = 1 - this.flattening;
    this.semiMinorAxis = this.semiMajorAxis * h, this.halfSemiMajorAxis = this.semiMajorAxis / 2, this.halfCircumference = Math.PI * this.semiMajorAxis, this.metersPerDegree = this.halfCircumference / 180, this.inverseFlattening = 1 / (1 - this.flattening) - 1, this.eccentricitySquared = e || 2 * this.flattening - this.flattening * this.flattening, this.meanRadiusSemiAxes = (2 * this.semiMajorAxis + this.semiMinorAxis) / 3;
  }

  _createClass(i, [{
    key: "radius",
    get: function get() {
      return this.semiMajorAxis;
    }
  }]);

  return i;
}();

var s = new i(6378137, 1 / 298.257223563, 3e5, .006694379990137799),
    t = new i(3396190, 1 / 169.8944472236118, 23e4),
    e = new i(1737400, 0, 0);
export { i as Ellipsoid, s as earth, t as mars, e as moon };